<template>
<nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top shadow-lg p-3" style="font-weight: bold">
  <a class="navbar-brand" href="/">U Zdichynců</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
    <div class="navbar-nav">
      <router-link  to="/ubytovani" data-toggle="collapse" data-target=".navbar-collapse.show" active-class="active" class="nav-item nav-link" >Ubytování</router-link>
      <router-link  to="/cenik" data-toggle="collapse" data-target=".navbar-collapse.show" active-class="active" class="nav-item nav-link">Ceník</router-link>
      <router-link  to="/sluzby" data-toggle="collapse" data-target=".navbar-collapse.show" active-class="active" class="nav-item nav-link">Služby</router-link>
      <router-link  to="/fotogalerie" data-toggle="collapse" data-target=".navbar-collapse.show" active-class="active" class="nav-item nav-link">Fotogalerie</router-link>
      <router-link  to="/kontakty" data-toggle="collapse" data-target=".navbar-collapse.show" active-class="active" class="nav-item nav-link">Kontakty</router-link>
    </div>
  </div>
</nav>
</template>

<script>
export default {
  name: "navbar",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
